import { mapActions, mapState } from 'vuex'
import validationMixin from '@components/mixins/validation'
import { errorMessages } from '@meta/errorMessages'

export default {
  name: 'AssignDomainModal',
  mixins: [validationMixin],
  props: {
    modalVisible: {
      required: true,
      type: Boolean,
    },
    targetCampaign: {
      required: true,
      type: String,
    },
    onActionComplete: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    const checkValidURL = (rule, value, callback) => {
      callback(this.validateURL(rule, value, callback))
    }

    return {
      showCreateCampaignDialog: false,
      selectPlaceholder: 'Select or start typing',
      domainDetailsForm: { url: '' },
      formRules: {
        url: [{ validator: checkValidURL, trigger: 'blur' }],
      },
      submitBtnLoading: false,
    }
  },
  watch: {
    domains(val) {
      if (this.domainDetailsForm.length === 0) {
        this.setCampaignWebsite(val[0], true)
      }
    },
  },
  computed: {
    ...mapState('domain', [
      'domains',
      'domainActionCompleted',
      'domainActionLoading',
      'domainActionError',
      'domainErrorMessage',
    ]),
    isFeatureLimitedDomains() {
      return this.$store.getters['plans/featureLimits/isFeatureLimited.domains']
    },
  },
  created() {
    if (this.domains.length > 0) {
      this.setCampaignWebsite(this.domains[0], true)
    }
  },
  methods: {
    ...mapActions('domain', [
      'createDomain',
    ]),
    submitForm() {
      this.submitBtnLoading = true
      this.$refs.domainDetailsForm.validate((valid) => {
        if (!valid) {
          this.submitBtnLoading = false
          return false // Form validation failed.
        }

        const domain = this.domains.find(
          domain => domain.url === this.domainDetailsForm.url)

        if (domain) {
          this.onActionComplete(domain.id)
          this.submitBtnLoading = false
          this.closeModal()
        } else {
          // Domain does not exist, so create the domain first
          this.createDomain({ url: this.domainDetailsForm.url })
            .then((domainID) => {
              if (this.domainActionCompleted &&
                !this.domainActionError) {
                this.onActionComplete(domainID)
              } else {
                this.$message({
                  type: 'error',
                  message: this.domainErrorMessage,
                })
                // console.error('Error creating domain')
              }

              this.closeModal()
              this.submitBtnLoading = false
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: errorMessages.default,
              })
              console.error('Error creating domain:', error)
              this.submitBtnLoading = false
            })
        }
      })
    },
    domainSelectVisibilityChange(value) {
      // hacky way to set the placeholder on every dropdown open
      if (value) {
        this.selectPlaceholder = 'Select or start typing'
        // this.selectPlaceholder = this.isFeatureLimitedDomains
        //   ? 'Select existing website'
        //   : 'Select or start typing'
      } else {
        this.selectPlaceholder = ''
      }
    },
    setCampaignWebsite(value, overrideLimit = false) {
      // hacky way to add domain when limit is not passed
      if (!this.isFeatureLimitedDomains || overrideLimit) {
        this.domainDetailsForm.url = JSON.parse(
          JSON.stringify(value.url))
      }
    },
    validateURL(rule, url, callback) {
      if (url === '') {
        return callback(new Error('Please input a website'))
      }

      this.domainDetailsForm.url = url = this.setHttp(url)
      // Disable domain check for development, so we can test on 'localhost'
      if (!this.validURL(url) && process.env.NODE_ENV !==
        'development') {
        return callback(new Error('Please input valid website URL'))
      }
    },
    closeModal() {
      this.$emit('close-modal')
    },
  },
}
